import { render, staticRenderFns } from "./PatientFormDetails.vue?vue&type=template&id=140e13b6"
import script from "./PatientFormDetails.vue?vue&type=script&lang=js"
export * from "./PatientFormDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports